<template>
  <el-dialog custom-class="p-dialog-custom" append-to-body :title="title" :visible.sync="show" :width="width"
    :before-close="close">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item>
        <div class="step">
          <span class="row num-txt" :class="{'op6':step!=1}"><i>1</i><span>发送验证码</span></span>
          <span class="row fh"><i class="el-icon-caret-right"></i></span>
          <span class="row num-txt" :class="{'op6':step!=2}"><i>2</i><span>重置密码</span></span>
        </div>
      </el-form-item>
      <el-form-item prop="mobile">
        <div class="mobile"><el-input maxlength="11" v-model="form.mobile" placeholder="请输入手机号"></el-input></div>
      </el-form-item>
      <el-form-item prop="yzm">
        <div class="mobile" v-if="ismobile"><el-input v-model="form.yzm" placeholder="请输入验证码"></el-input>
        </div>
      </el-form-item>
    </el-form>
    <div class="yzm"><el-button type="primary" :disabled="loading" round @click="sendYzm">{{btnTitle}}</el-button></div>
  </el-dialog>
</template>

<script>
  import API from '@/api/user'
  import {
    isMobile
  } from '@/utils/validate'
  export default {
    props: {
      title: {
        //标题名称
        type: String,
        default: '找回密码'
      },
      content: {
        type: String
      },
      show: {
        type: Boolean,
        default () {
          return false;
        }
      },
      width: {
        type: String,
        default () {
          return '30%';
        }
      }
    },
    data() {
      var validatePhone = (rule, value, callback) => {
        setTimeout(() => {
          if (!isMobile(value)) {
            callback(new Error('请输入正确的手机号码'))
          } else {
            callback()
          }
        }, 100)
      }
      return {
        loading: false,
        btnTitle: '获取验证码',
        step: 1,
        ismobile: false,
        form: {
          mobile: '',
          yzm: ''
        },
        rules: {
          mobile: [{
              required: true,
              message: '手机号不能为空',
              trigger: 'blur'
            },
            {
              min: 11,
              max: 11,
              message: '请输入11位手机号码',
              trigger: 'blur'
            },
            {
              validator: validatePhone,
              trigger: 'blur'
            }
          ],
        },
        yzm: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }]
      };
    },
    methods: {
      close() {
        this.$emit('close');
      },
      yzMobile(v) {
        return isMobile(v)
      },
      clear() {
        this.step = 1
        this.ismobile = false
        this.form.mobile = ''
        this.form.yzm = ''
        this.btnTitle = '获取验证码'
      },
      sendYzm() {
        let self = this
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            this.loading = true
            setTimeout(function() {
              self.loading = false
              if (self.step == 1) {
                self.sendSms()
              }
              if (self.step == 2) {
                self.resetPassword()
              }
            }, 1000)
          }
        })
      },
      sendSms() {
        API.sendVerificationCode({
          telPhoneNum: this.form.mobile
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('发送成功')
            this.ismobile = true
            this.step = 2
            this.btnTitle = '重置密码'
          }
        })
      },
      resetPassword() {
        API.resetUserPasswordWithVerificationCode({
          telPhoneNum: this.form.mobile,
          verificationCode: this.form.yzm
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('重置成功')
            this.close()
          }
        })
      }
    },
    mounted() {}
  };
</script>

<style lang="scss">
  .p-dialog-custom {
    // background-color: #03317d !important;

    .el-dialog__header {
      background-color: #1C6ED5;
      line-height: 16px !important;
      padding: 10px 20px;

      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }

      .el-dialog__headerbtn {
        top: 12px;

        .el-dialog__close {
          font-size: 16px;
          color: #fff;
        }
      }
    }

    .el-dialog__body {
      color: #2B2E34;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 600;

      .warning {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background-color: #F29e0b;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
        text-align: center;
        margin-right: 16px;
        position: relative;

        &span {
          position: absolute;
        }
      }

      .el-form-item__error {
        margin-left: 50px !important;
      }

      .op6 {
        opacity: 0.6 !important;
      }

      .step {
        display: flex;
        justify-content: space-around;
      }

      .mobile {
        text-align: center;

        .el-input {
          width: 84%;

          .el-input__inner {
            border-radius: 20px !important;
          }
        }
      }

      .yzm {
        margin-top: 10px;
        text-align: center;

        .el-button {
          width: 84%;
        }
      }

      .num-txt {
        opacity: 1;
        display: flex;
        align-items: center;

        i {
          background-color: #1C6ED5;
          color: #fff;
          font-size: 28px;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: normal;
        }

        span {
          color: #1C6ED5;
          margin-left: 10px;
        }
      }

      .fh {
        display: flex;
        align-items: center;

        i {
          color: #1C6ED5;
          font-size: 28px;
        }
      }
    }

    .f-dialog-footer {
      .el-button--default {
        background-color: #A0B1D3;
        color: #FFFFFF;
        border-color: #A0B1D3;
      }

      .el-button--primary {
        background-color: #1C6ED5;
        color: #FFFFFF;
        border-color: #1C6ED5;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/components/dialog.vue